import {Component, ElementRef, EventEmitter, forwardRef, OnInit, Output, ViewChild} from '@angular/core';
import {AutocompleteComponent} from '../autocomplete/autocomplete.component';
import {FormElementsService} from '../../services/form-elements.service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-autocomplete-string-select',
  templateUrl: './autocomplete-string-select.component.html',
  styleUrls: ['./autocomplete-string-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteStringSelectComponent),
      multi: true
    }
  ]
})
export class AutocompleteStringSelectComponent extends AutocompleteComponent implements OnInit, ControlValueAccessor {
  @Output() inputValidationState = new EventEmitter();
  @ViewChild('inputElement') inputElement: ElementRef;
  public allOptions;

  constructor(protected formElementsService: FormElementsService) {
    super(formElementsService);
  }

  ngOnInit(): void {
    this.formElementsService.getOptionList(this.inputId, '', this.context).then(res => this.allOptions = res);
    this.actualValue = this.ngModelObject;
  }

  public setSelectedOption(event?: any): void {
    const valueToEmit = this.getValueToEmit(event);
    switch (this.inputId) {
      // TODO: change to VTC.StudyField?
      case 'Vupch.studyField':
        this.emitValue(valueToEmit?.name, this.objectToSet);
        break;
      case 'StudyProgramme.department':
        this.emitValue(valueToEmit?.name, this.objectToSet);
        break;
      default:
        this.emitValue(valueToEmit, this.objectToSet);
    }
    this.inputValidationState.emit(true);
  }

  public checkInputValidity(): void {
    this.inputValidationState.emit(this.inputElement.nativeElement.classList.contains('ng-valid'));
  }

  public getOptions(value: string): void {
    if (this.inputId === 'Vupch.studyField') {
      value = value ? value.toLowerCase() : '';
      this.optionObjects = this.allOptions.filter(element => {
        if (element.name.indexOf(value) !== -1) {
          return true;
        }
      });
      this.options = this.displayProperty ?
        this.optionObjects.map(option => option[this.displayProperty]) :
        this.optionObjects.map(option => option.name ? option.name : option);
    } else {
      super.getOptions(value);
    }
  }
}
